import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import ElementPlus from 'element-plus';
import router from './router'; // Import the router

import 'element-plus/dist/index.css';
import '@/styles/tailwind.css';
import '@/styles/_admin.scss';
import '@/styles/_stats.scss';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

// Create the app instance
const app = createApp(App);
const pinia = createPinia();
// Use ElementPlus and Router
app.use(ElementPlus);
app.use(router); // Use the router

// Mount the app
app.use(pinia);
app.mount('#app');